// extracted by mini-css-extract-plugin
export default {"header":"ReportsHeader_header__716lk","dashboardTop":"ReportsHeader_dashboardTop__NjJu1"};